import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import Layout from "./components/Layout";
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import AdminManagementPage from "./pages/AdminManagementPage";
import BotManagementPage from "./pages/BotManagementPage";
import BotSettingsPage from "./pages/BotSettingsPage";
import EditBotPage from "./pages/EditBotPage";
import BroadcastPage from "./pages/BroadcastPage";
import BroadcastReportsPage from "./pages/BroadcastReportsPage";
import UserReportsPage from "./pages/UserReportsPage";
import MobileReportsPage from "./pages/MobileReportsPage";
import ScheduledBroadcastPage from "./pages/ScheduledBroadcastPage";
import CreditManagementPage from "./pages/CreditManagementPage";
import ChannelBroadcastPage from "./pages/ChannelBroadcastPage";
import ChatPage from "./pages/ChatPage";
import BotLiveChatPage from "./pages/BotLiveChatPage";
import StaffPage from "./pages/StaffPage";
import AutoMessagesPage from "./pages/AutoMessagesPage";
import WhatsAppAPIsPage from "./pages/WhatsAppAPIsPage";
import WhatsAppChatPage from "./pages/WhatsAppChatPage";
import AdminAlertsPage from "./pages/AdminAlertsPage";
import AdminSettingsPage from "./pages/AdminSettingsPage";
import ReportsPage from "./pages/ReportsPage";
import SystemHealthPage from "./pages/SystemHealthPage";
import BotAutomationPage from "./pages/BotAutomationPage";
import CloudAIPage from "./pages/CloudAIPage";
import { Toaster } from "sonner";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-muted-foreground">Loading...</div>
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/app/dashboard" replace />;
  return children;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
            <Route path="/app" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route index element={<Navigate to="/app/dashboard" replace />} />
              <Route path="dashboard" element={<DashboardPage />} />
              <Route path="admins" element={<AdminManagementPage />} />
              <Route path="bots" element={<BotManagementPage />} />
              <Route path="bot-settings" element={<BotSettingsPage />} />
              <Route path="edit-bot" element={<EditBotPage />} />
              <Route path="broadcast" element={<BroadcastPage />} />
              <Route path="scheduled-broadcast" element={<ScheduledBroadcastPage />} />
              <Route path="broadcast-reports" element={<BroadcastReportsPage />} />
              <Route path="user-reports" element={<UserReportsPage />} />
              <Route path="mobile-reports" element={<MobileReportsPage />} />
              <Route path="credits" element={<CreditManagementPage />} />
              <Route path="channel-broadcast" element={<ChannelBroadcastPage />} />
              <Route path="chat" element={<ChatPage />} />
              <Route path="bot-live-chat" element={<BotLiveChatPage />} />
              <Route path="staff" element={<StaffPage />} />
              <Route path="auto-messages" element={<AutoMessagesPage />} />
              <Route path="whatsapp-apis" element={<WhatsAppAPIsPage />} />
              <Route path="whatsapp-chat" element={<WhatsAppChatPage />} />
              <Route path="admin-alerts" element={<AdminAlertsPage />} />
              <Route path="admin-settings" element={<Navigate to="/app/dashboard" replace />} />
              <Route path="reports" element={<ReportsPage />} />
              <Route path="system-health" element={<SystemHealthPage />} />
              <Route path="bot-automation" element={<BotAutomationPage />} />
              <Route path="cloud-ai" element={<BotAutomationPage />} />
              <Route path="bot-cloud-ai" element={<BotAutomationPage />} />
            </Route>
            <Route path="/dashboard" element={<Navigate to="/app/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
